import type { TOC } from '@ember/component/template-only';
import { filterBy } from '@nullvoxpopuli/ember-composable-helpers';
import { eq } from 'ember-truth-helpers';
import LegalDocumentsStatus from 'garaje/components/legal-documents-status';
import type { AgreementsStatus } from 'garaje/models/agreeable';
import type PlatformJob from 'garaje/models/platform-job';

interface PluginActivityColumnNdaSignature {
  Args: {
    agreementsStatus: AgreementsStatus;
    platformJobs: Record<string, PlatformJob[]>;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="table-cell border-b align-top px-2 pt-6 text-carbon-50 flex" ...attributes>
    <ul class="list-none p-0 m-0 leading-normal">
      <li>
        <LegalDocumentsStatus @status={{@agreementsStatus}} data-test-id="nda-status" />
      </li>
      {{#each-in @platformJobs as |pluginName jobs|}}
        {{#let (filterBy "status" "done" jobs) as |doneJobs|}}
          <li data-test-platform-job>
            {{#if (eq doneJobs.length jobs.length)}}
              <img src="/assets/images/checkmark-small-gray.svg" class="flex-none" alt="completed" />
              <span class="whitespace-nowrap" data-test-platform-job-status="done">
                {{pluginName}}
              </span>
            {{else}}
              <img src="/assets/images/cross-small-gray.svg" class="flex-none" alt="incomplete" />
              <span class="whitespace-nowrap" data-test-platform-job-status="incomplete">
                {{pluginName}}
              </span>
            {{/if}}
          </li>
        {{/let}}
      {{/each-in}}
    </ul>
  </div>
</template> satisfies TOC<PluginActivityColumnNdaSignature>;
